<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <div style="margin-left: 10vw;" class="chat1" >“사용자가 몰려서 서버가 다운되었어요 🤯”</div>
        <div style="margin-left: 32vw;" class="chat1">“서버 용량이 꽉찼어요. 이사가야 하나요? 😱”</div>
        <div style="margin-left: 11vw;" class="chat1">“사용자가 늘어서 DB를 확장해야 하네요 😥”</div>
        <div style="margin-left: 31vw;" class="chat1">
          “서버 패치해야 해서 잠시 점검중 팝업 띄웁니다 🚨”
        </div>
        <div style="margin-left: 13vw;" class="chat1">
          “아직 사용자도 없는데 서버비용이 왜이렇게 많이 나오죠? 💸”
        </div>
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "./Caption.vue";

export default {
  components: {
    Caption,
  },
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: fit-content;
  background-color: #ecf3fa;
  position: relative;
  overflow: hidden;
}

.content {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  padding: 50px 20px 50px 20px;
}

.chat1 {
  width: fit-content;
  margin-bottom: 30px;
  background-color: #ffffff;
  border-radius: 20px;
  padding: 10px 10px 10px 10px;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: fit-content;
    background-color: #ecf3fa;
    position: relative;
    overflow: hidden;
  }

  .content {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: 100%;
    max-width: 1140px;
    padding: 50px 20px 50px 20px;
  }

  .chat1 {
    width: fit-content;
    margin-bottom: 20px;
    background-color: #ffffff;
    border-radius: 20px;
    padding: 10px 10px 10px 10px;
    margin-left: 0px;
  }
}
</style>
  